module.exports = __webpack_public_path__ + "img/template-demo-1.71cf7bf1.jpg";